var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M5.375 56V37.375L45.375 32L5.375 26.625V8L61.375 32L5.375 56Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }